export enum GoodwillAppAccess {
  GOODWILL_FRONT = 1,
  GOODWILL_CSM = 2
}
